import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Subject, BehaviorSubject, Observable } from 'rxjs';
import { Popup, PopupState } from '@models/popup';

const STYLES = {
  default: {
    type: 'info',
    icon: 'glicon-info'
  },
  question: {
    type: 'question',
    icon: 'glicon-help'
  },
  success: {
    type: 'success',
    icon: 'glicon-circle-check'
  },
  error: {
    type: 'error',
    icon: 'glicon-alert-thin'
  },
  warning: {
    type: 'warning',
    icon: 'glicon-report-problem'
  }
};
@Injectable()
export class PopUpService {
  private popupState: Popup = {
    open: false
  };
  private state: Subject<PopupState> = new Subject<PopupState>();
  public popUpSubject: BehaviorSubject<Popup> = new BehaviorSubject<Popup>(this.popupState);

  constructor(public translate: TranslateService) {}

  public getPopupState$(): Observable<Popup> {
    return this.popUpSubject.asObservable();
  }

  openPopup(options: Popup): Promise<Popup> {
    this.popUpSubject.next({ ...options, open: true });
    return new Promise((resolve, reject) => {
      this.state = new Subject();
      this.state.subscribe((popupState: PopupState) => {
        if (popupState.isAccepted || !!popupState.hasAction) {
          return resolve(null);
        }
        return reject('cancel');
      });
    });
  }

  showConfirm(options: any): Promise<any> {
    const popupStyle = options.type ? STYLES[options.type] || STYLES.question : STYLES.question;
    return this.openPopup({
      ...options,
      ...popupStyle,
      showCancelButton: true
    });
  }

  showSuccess(options: any): Promise<any> {
    return this.openPopup({ ...options, ...STYLES.success });
  }

  showError(options: any): Promise<any> {
    return this.openPopup({ ...options, ...STYLES.error });
  }

  showWarning(options: any): Promise<any> {
    return this.openPopup({ ...options, ...STYLES.warning });
  }

  closePopup(action?: any) {
    this.state.next({ isAccepted: false, hasAction: action });
    this.popUpSubject.next({ open: false });
  }

  confirmPopup() {
    this.state.next({ isAccepted: true, hasAction: false });
    this.closePopup();
  }

  question(options): Promise<any> {
    return this.showConfirm(options);
  }
  confirm(options): Promise<any> {
    return this.showConfirm(options);
  }
  confirmDelete(options): Promise<any> {
    return this.showConfirm(options);
  }
  confirmWarning(options): Promise<any> {
    return this.showConfirm(options);
  }
}
